export { default } from './FuseAnimate'
